import React, { useCallback, useEffect, useState } from "react";
import "./index.scss";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";

import { RequestDialog } from "../../components/consult";
import { ReactComponent as ArrowLeft } from "../../static/icons/arrow-left.svg";
import {
  CounselingField,
  requestState,
  UsePeriod,
} from "../../store/RequestStore";
import { useLocalStorage } from "../../shared/utill";
import { useMediaQuery } from "react-responsive";
import { consult22EventAtom } from "../../store/EventStore";
import ConsultSelectEvent from "../../components/consult/ConsultSelect/ConsultSelectEvent/ConsultSelectEvent";

const Consult2_2 = () => {
  const [searchParams] = useSearchParams();
  const [request, setRequest] = useRecoilState(requestState);
  const [consult22EventState, setConsult22EventState] =
    useRecoilState(consult22EventAtom);
  const [persistedRequest, setPersistedRequest] = useLocalStorage(
    "request",
    request
  );
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState<boolean>(false);

  const isMobile = useMediaQuery({
    query: "(max-width: 1200px)",
  });

  useEffect(() => {
    setConsult22EventState(true);
    setLoaded(true);
  }, []);

  const onOpen = () => {
    setDialogVisible(true);
  };

  useEffect(() => {
    const hasEvent = searchParams.get("has_event") === "true";
    const eventType = searchParams.get("event_type");
    if (hasEvent) {
      let usePeriod = undefined;
      switch (eventType) {
        case "0_12":
          usePeriod = UsePeriod._12;
          break;
        case "0_24":
          usePeriod = UsePeriod._24;
          break;
      }
      setRequest({
        ...request,
        counselingType: CounselingField.DEFAULT,
        usePeriod,
      });
      onOpen();
    }
  });

  useEffect(() => {
    if ((window as any).fbq) {
      (window as any).fbq("track", "Optimization2");
    }
  }, []);
  const onClose = () => {
    // document.body.style.overflow = "auto";

    const hasEvent = searchParams.get("has_event") === "true";
    if (hasEvent) {
      const eventType = searchParams.get("event_type");
      const search = location.search.replace(
        /&has_event=true&event_type=(.*)/,
        ""
      );
      switch (eventType) {
        case "0_12":
        case "0_24":
          window.location.href = "https://balancespace-event.co.kr/" + search;
      }
    } else {
      setDialogVisible(false);
    }
  };

  const onSubmitSuccess = useCallback(() => {
    // document.body.style.overflow = "auto";

    const hasEvent = searchParams.get("has_event") === "true";
    if (hasEvent) {
      const eventType = searchParams.get("event_type");
      const search = location.search.replace(
        /&has_event=true&event_type=(.*)/,
        ""
      );
      switch (eventType) {
        case "0_12":
        case "0_24":
          window.location.href = "https://balancespace-event.co.kr/" + search;
      }
    } else {
      navigate(`/${location.search}`);
    }
  }, []);

  const selectOption = (period: UsePeriod) => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
    // document.body.style.overflow = "hidden";

    const script = document.createElement("script");

    script.type = "text/javascript";
    script.text = `
      var across_adn_complete_contain = new fn_across_adn_contain();
      var across_adn_complete_param = [];
      across_adn_complete_param = {"ut":"Complete","ui":"107325","uo":"types1"};
      across_adn_complete_contain.init(across_adn_complete_param);
    `;

    document.body.appendChild(script);

    setRequest({ ...request, usePeriod: period });
    setPersistedRequest(request);
    onOpen();
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, []);

  useEffect(() => {
    if (dialogVisible)
      window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [dialogVisible]);

  useEffect(() => {
    const counselingType = searchParams.get("counselingType");
    if (counselingType) {
      setRequest({
        ...request,
        counselingType: counselingType as CounselingField,
      });
    }
  }, [setRequest, request, searchParams]);

  return !loaded ? (
    <></>
  ) : (
    <div
      className="consult"
      id="consult2"
      style={isMobile ? { paddingLeft: "10px", paddingRight: "10px" } : {}}
    >
      <div className="consult-content">
        <div className="header-page-title-wrapper">
          <div className="back-button" onClick={() => navigate("/consult")}>
            <ArrowLeft />
          </div>
          <div className="header-page-title">상담 신청</div>
          {isMobile && <div className="dummy"></div>}
        </div>

        {!dialogVisible && (
          <div className="1200:py-[100px]">
            {/* <div className="flex flex-col items-center w-full">
              <img
                className="w-[175px] h-[26px] 1200r:w-[100px] 1200r:h-[15px]"
                src={"/assets/logo-balance.svg"}
                alt=""
              />
            </div> */}
            <div className="mt-[40px] 1200r:mt-[30px] flex flex-col text-[30px] 1200r:text-[22px] font-[800] leading-[40px] 1200r:leading-[32px] text-[#404040]">
              {isMobile && <div>오직</div>}
              <div className="flex flex-row items-center justify-center">
                {!isMobile && <div>오직</div>}
                <img
                  className="w-[235px] 1200r:w-[180px] mx-[10px] 1200r:mx-[4px] mb-[4px]"
                  src={"/assets/logo-sr.png"}
                  alt=""
                />
                <span className="text-[#275AFF]">고객님</span>에게만!
              </div>
              <div> 세이브오피스시크릿 혜택</div>
            </div>
            <div className="mt-[24px] 1200r:mt-[8px] text-[16px] 1200r:text-[14px] font-[600] leading-[24px] 1200r:leading-[20px] text-[#404040]">
              단 3일, 최대 198,000원 할인 + 3개월 추가 역대급 혜택!
            </div>
            <div
              className="cursor-pointer mb-[50px] 1200r:mb-[36px] mt-[40px] 1200r:mt-[30px] text-[16px] font-[700] text-white px-[30px] bg-[#275AFF] w-fit rounded-full py-[12px] mx-auto hover:opacity-80 1200r:text-[14px]"
              onClick={() => navigate("/")}
            >
              세이브오피스 자세히 알아보기
            </div>
            <div className="relative pointer-events-none">
              <div className="absolute w-full">
                <div className="relative w-full z-[10]">
                  <img
                    className="w-[160px] h-[160px] 1200r:w-[64px] 1200r:h-[64px] -translate-x-[130px] translate-y-[200px] 1200r:-translate-x-[45px] 1200r:translate-y-[308px]"
                    src={"/assets/deco1.png"}
                    alt=""
                  />
                </div>
              </div>
              <div className="absolute w-full">
                <div className="relative w-full 1200r:z-[10]">
                  <img
                    className="w-[160px] h-[160px] 1200r:w-[64px] 1200r:h-[64px] ml-auto translate-x-[120px] -translate-y-[90px] 1200r:translate-x-[20px] 1200r:-translate-y-[45px]"
                    src={"/assets/deco2.png"}
                    alt=""
                  />
                </div>
              </div>
            </div>
            {request.counselingType === "A.비상주+세무" && (
              <div
                className="header-card"
                style={
                  !isMobile
                    ? {
                        transform: "translate(10px, 10px)",
                      }
                    : {
                        transform: "translate(4px, 10px)",
                      }
                }
              >
                <div>비상주 사무실 단독</div>
                <div className="header-card-vertical-divider">|</div>
                <div
                  className="header-card-badge"
                  style={{ background: "#5B7CFF" }}
                >
                  결합 A형
                </div>
              </div>
            )}
            {request.counselingType === "B.비상주+세무+법인설립" && (
              <div
                className="header-card"
                style={
                  !isMobile
                    ? {
                        transform: "translate(0px, 10px)",
                      }
                    : {
                        transform: "translate(4px, 10px)",
                      }
                }
              >
                <div>비상주 사무실 단독</div>
                <div className="header-card-vertical-divider-b">|</div>
                <div
                  className="header-card-badge"
                  style={
                    isMobile
                      ? { background: "#2DBCFF" }
                      : { background: "#2DBCFF", width: "232px" }
                  }
                >
                  결합 B형
                </div>
              </div>
            )}
            <div className="card-outer-wrapper">
              <ul
                className="card-wrapper-event"
                style={
                  request.counselingType === "B.비상주+세무+법인설립" &&
                  !isMobile
                    ? { width: "400px" }
                    : {}
                }
              >
                <ConsultSelectEvent
                  title="6개월"
                  titleEvent="+1개월"
                  price={"총 결제 금액 231,000원"}
                  ogPrice={"44,000원"}
                  monthPrice={"33,000원"}
                  onClick={() => selectOption(UsePeriod._6)}
                  type={request.counselingType}
                />
                <ConsultSelectEvent
                  title="12개월"
                  titleEvent="+2개월"
                  price={"총 결제 금액 330,000원"}
                  ogPrice={"33,000원"}
                  monthPrice={"23,571원"}
                  onClick={() => selectOption(UsePeriod._12)}
                  type={request.counselingType}
                />
                <ConsultSelectEvent
                  title="24개월"
                  titleEvent="+2개월"
                  price={"총 결제 금액 528,000원"}
                  ogPrice={"27,500원"}
                  monthPrice={"20,308원"}
                  onClick={() => selectOption(UsePeriod._24)}
                  type={request.counselingType}
                />
                <ConsultSelectEvent
                  title="36개월"
                  titleEvent="+3개월"
                  price={"총 결제 금액 673,200원"}
                  ogPrice={"24,200원"}
                  monthPrice={"17,262원"}
                  onClick={() => selectOption(UsePeriod._36)}
                  type={request.counselingType}
                />

                {request.counselingType === "B.비상주+세무+법인설립" &&
                  isMobile && (
                    <div className="b-special-card-m">
                      <img
                        className="b-card-plus-icon-2"
                        src="/assets/icons/plus2.svg"
                        alt=""
                      />
                      <div className="b-card-content-1-m">
                        {"결합 B형! 법인설립 수수료"}
                      </div>
                      <div className="b-card-content-m-wrapper">
                        <div className="b-card-content-2-m">평균550,000원</div>
                        <div className="b-card-content-3-m">▶</div>
                        <div className="b-card-content-4-m">0원</div>
                      </div>
                    </div>
                  )}
              </ul>
              {request.counselingType === "B.비상주+세무+법인설립" &&
                !isMobile && (
                  <div className="b-special-card">
                    <img
                      className="b-card-plus-icon-1"
                      src="/assets/icons/plus1.svg"
                      alt=""
                    />
                    <div className="b-card-content-1">{"법인설립\n수수료"}</div>
                    <div className="b-card-content-2">0원</div>
                    <div className="b-card-content-3">평균 550,000원</div>
                  </div>
                )}
            </div>
            <div className="ghost-wrapper">
              <p className="ghost">VAT 포함</p>
              <p className="small">선릉점, 신논현점 금액 별도 문의</p>
            </div>
            {request.counselingType !== CounselingField.DEFAULT ? (
              <p className="small">세무기장료 별도 발생</p>
            ) : (
              <></>
            )}
            <div className="discount-ghost-wrapper">
              <div className="text-[14px] font-[800] leading-[26px] text-[#3D3D3D] mb-[8px]">
                프로모션 유의사항
              </div>
              <ul className="discount-ul">
                <li className="discount-li">
                  본 혜택은 시크릿 이벤트로 현재 페이지에서 신청하신 고객님께만
                  제공됩니다.
                </li>
                <li className="discount-li">
                  본 프로모션은 다른 이벤트 또는 할인 혜택과 중복 적용이 제한될
                  수 있습니다.
                </li>
                <li className="discount-li">
                  본 프로모션은 당사 사정에 따라 사전 공지 없이 변경되거나
                  종료될 수 있습니다.
                </li>
              </ul>
            </div>
          </div>
        )}

        <RequestDialog
          visible={dialogVisible}
          onSubmitSuccess={onSubmitSuccess}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default Consult2_2;
